import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import AttenteRequete from '../../../../hoc/AttenteRequete/AttenteRequete';
import FormulaireSelectionProjet from '../../../Capteur/Ajouter/FormulaireSelectionProjet/FormulaireSelectionProjet';
import Bouton from '../../../UI/Bouton/Bouton';
import { checkMot } from '../../../../ressources/functionJS/checkMot';
import * as glossaire_pattern from '../../../../ressources/glossaires/glossaire_pattern';
import * as requestType from '../../../../ressources/glossaires/glossaire_requetes';
import * as type_btn from '../../../../ressources/glossaires/glossaire_type_de_bouton';
import * as actions from '../../../../services/actions';
import MessageErreur, {
  classeChampEnErreur,
} from '../../../UI/MessageErreur/MessageErreur';
import {
  schemaNouvelleAlarmeXY,
  schemaModificationAlarmeXY,
} from '../../../../services/schemas/alarmeXY';
import {
  validerFormulaire,
  messageDuChamp,
} from '../../../../services/schemas/validerFormulaire';
import { AiOutlineCheck } from 'react-icons/ai';
import * as s from '../../../../ressources/StyleGlobal/StyleGlobal';
import styles from './FormulaireAlarmeXY.module.scss';

const FormulaireAlarmeXY = (props) => {
  const dispatch = useDispatch();
  const [formulaireAlarmeXY, setFormulaireAlarmeXY] = useState({
    project_id: null,
    template_id: null,
    Xsensor_id: null,
    Ysensor_id: null,
    Xcomponent_id: null,
    Ycomponent_id: null,
  });
  const [erreurs, setErreurs] = useState({});
  const erreurDuChamp = (champ) => messageDuChamp(erreurs, champ);

  useEffect(() => {
    if (props.preconfigurerAlarmeXY) {
      setFormulaireAlarmeXY({
        ...props.preconfigurerAlarmeXY,
      });
    }
  }, [props.preconfigurerAlarmeXY]);

  const gererEnvoi = () => {
    // Les identifiants partent tels que tapés : le schéma les convertit et
    // refuse avec un message ce qui n'en est pas. Ils partaient jusqu'ici en
    // chaînes, « abc » compris, et un champ vide en null.
    const enCreation = props.preconfigurerAlarmeXY === undefined;
    const charge = {
      project_id: formulaireAlarmeXY.project_id,
      template_id: formulaireAlarmeXY.template_id,
      Xsensor_id: formulaireAlarmeXY.Xsensor_id,
      Xcomponent_id: formulaireAlarmeXY.Xcomponent_id,
      Ysensor_id: formulaireAlarmeXY.Ysensor_id,
      Ycomponent_id: formulaireAlarmeXY.Ycomponent_id,
    };
    if (!enCreation) {
      charge.alarm_xy_id = props.preconfigurerAlarmeXY.alarm_xy_id;
    }

    const resultat = validerFormulaire(
      enCreation ? schemaNouvelleAlarmeXY : schemaModificationAlarmeXY,
      charge
    );
    setErreurs(resultat.erreurs);
    if (!resultat.valide) {
      return;
    }

    if (enCreation) {
      dispatch(actions.reqCreerAlarmesXY(resultat.donnees));
    } else {
      dispatch(actions.reqModifierAlarmesXY(resultat.donnees));
    }
  };

  // Mises à jour à partir de l'état courant, et gererProjetId stable d'un
  // rendu à l'autre : FormulaireSelectionProjet la liste dans les dépendances
  // de son useEffect et l'appelle tant qu'aucun projet n'est choisi. Recréée
  // à chaque rendu, elle entretenait une boucle de rendus dans laquelle
  // chaque rappel réécrivait l'état d'avant et effaçait la saisie.
  const gererEtatDeCibleName = (event) => {
    const { name, value } = event.target;
    setFormulaireAlarmeXY((prev) => ({ ...prev, [name]: value }));
  };

  const gererProjetId = useCallback(
    (projetId) =>
      setFormulaireAlarmeXY((prev) => ({ ...prev, project_id: projetId })),
    []
  );
  const affichageFormulaire = (style, label_state, label_name, pattern) => {
    const erreur = erreurDuChamp(label_state);
    // À la création, value valait null : l'input basculait en non contrôlé.
    // On lit l'état dans les deux cas.
    const valeur = formulaireAlarmeXY[label_state];
    const classes = [s.form_control, erreur ? classeChampEnErreur : ''].join(
      ' '
    );
    switch (pattern) {
      case glossaire_pattern.array:
        return (
          <div className={[style, styles.style].join(' ')}>
            <span className={[styles.stil2].join(' ')}>{label_name}</span>
            <input
              type="text"
              pattern={pattern}
              className={classes}
              placeholder={label_state}
              name={label_state}
              value={valeur === undefined ? '' : JSON.stringify(valeur)}
              disabled={props.affichageProfil === true}
              onChange={(event) => gererEtatDeCibleName(event)}
            />
            <MessageErreur cle={erreur} />
          </div>
        );
      default:
        return (
          <div className={[style, styles.style].join(' ')}>
            <span className={[styles.stil2].join(' ')}>{label_name}</span>
            <input
              type="text"
              pattern={pattern}
              className={classes}
              placeholder={label_state}
              name={label_state}
              value={valeur ?? ''}
              disabled={props.affichageProfil === true}
              onChange={(event) => gererEtatDeCibleName(event)}
            />
            <MessageErreur cle={erreur} />
          </div>
        );
    }
  };

  return (
    <>
      <div className={[s.row].join(' ')}>
        <div className={styles.ConteneurInfo}>
          <div className={[s.container, s.text_left].join(' ')}>
            <form onSubmit={(event) => event.preventDefault()} noValidate>
              <div className={s.form_group}>
                <div className={[s.form_row, s.align_items_center].join(' ')}>
                  {/**DEBUT project_id**/}
                  <FormulaireSelectionProjet
                    affichageProfil={props.affichageProfil}
                    gererProjetId={gererProjetId}
                    preconfigurerProjetId={formulaireAlarmeXY.project_id}
                  />
                  <MessageErreur cle={erreurDuChamp('project_id')} />
                  {/**FIN project_id**/}
                  {/**DEBUT Xsensor_id**/}
                  {affichageFormulaire(
                    s.col_12,
                    'Xsensor_id',
                    checkMot('xsensor_id'),
                    glossaire_pattern.integer
                  )}
                  {/**FIN Xsensor_id**/}
                  {/**DEBUT Ysensor_id**/}
                  {affichageFormulaire(
                    s.col_12,
                    'Ysensor_id',
                    checkMot('ysensor_id'),
                    glossaire_pattern.integer
                  )}
                  {/**FIN Ysensor_id**/}
                  {/**DEBUT Xcomponent_id**/}
                  {affichageFormulaire(
                    s.col_12,
                    'Xcomponent_id',
                    checkMot('xcomponent_id'),
                    glossaire_pattern.integer
                  )}
                  {/**FIN Xcomponent_id**/}
                  {/**DEBUT Ycomponent_id**/}
                  {affichageFormulaire(
                    s.col_12,
                    'Ycomponent_id',
                    checkMot('ycomponent_id'),
                    glossaire_pattern.integer
                  )}
                  {/**FIN Ycomponent_id**/}
                  {/**DEBUT template_id**/}
                  {affichageFormulaire(
                    s.col_12,
                    'template_id',
                    checkMot('template_id'),
                    glossaire_pattern.integer
                  )}
                  {/**FIN template_id**/}
                </div>
              </div>
              {props.affichageProfil === true ? null : (
                <div className={s.form_group}>
                  <div
                    className={[s.d_flex, s.justify_content_between].join(' ')}
                  >
                    <div>
                      <Bouton
                        type={type_btn.danger}
                        cliquer={(e) => {
                          e.preventDefault();
                          props.annuler();
                        }}
                      >
                        {checkMot('annuler')}
                      </Bouton>
                    </div>
                    <div
                      className={[s.d_flex, s.justify_content_between].join(
                        ' '
                      )}
                    >
                      {props !== undefined &&
                      props.preconfigurerAlarmeXY === undefined ? (
                        <AttenteRequete
                          request_type={requestType.configurer_des_alarmes_xy}
                          str={checkMot('creation_en_cour')}
                        >
                          <Bouton
                            type={type_btn.succes}
                            ajoutClass={styles.Bts}
                            cliquer={() => gererEnvoi()}
                          >
                            <AiOutlineCheck />
                            {checkMot('creer')}
                          </Bouton>
                        </AttenteRequete>
                      ) : (
                        <AttenteRequete
                          request_type={requestType.modifier_des_alarmes_xy}
                          str={checkMot('modification_en_cour')}
                        >
                          <Bouton
                            type={type_btn.succes}
                            cliquer={() => gererEnvoi()}
                          >
                            {checkMot('enregistrer')}
                          </Bouton>
                        </AttenteRequete>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormulaireAlarmeXY;
